import { Component, OnInit } from '@angular/core';
import {Recipe } from '../recipe.model'
@Component({
  selector: 'app-recipe-list',
  templateUrl: './recipe-list.component.html',
  styleUrls: ['./recipe-list.component.css']
})
export class RecipeListComponent implements OnInit {
  recipes: Recipe[] = [
    new Recipe('Test Recipe','This is only a test','https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9P2yy3h7p7A7QqNr5tlkAw4FicweeaYAn54mYupx0dlRWekLquA'),
    new Recipe('Test Recipe 2','This is another a test','https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9P2yy3h7p7A7QqNr5tlkAw4FicweeaYAn54mYupx0dlRWekLquA')
 ];
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recipes/recipe-list/recipe-list.component.ts